export const GET_ORG_TYPES = 'accreditation-companies-modal/GET_ORG_TYPES';
export const getOrgTypesAction = () => ({
	type: GET_ORG_TYPES,
});

export const SET_ORG_TYPES = 'accreditation-companies-modal/SET_ORG_TYPES';
export const setOrgTypesAction = payload => ({
	type: SET_ORG_TYPES,
	payload,
});
export const SET_IS_ORG_TYPES_LOADING = 'accreditation-companies-modal/SET_IS_ORG_TYPES_LOADING';
export const setIsOrgTypesLoading = payload => ({
	type: SET_IS_ORG_TYPES_LOADING,
	payload,
});

export const GET_TAX_SYSTEMS = 'accreditation-companies-modal/GET_TAX_SYSTEMS';
export const getTaxSystemsAction = () => ({
	type: GET_TAX_SYSTEMS,
});

export const SET_TAX_SYSTEMS = 'accreditation-companies-modal/SET_TAX_SYSTEMS';
export const setTaxSystemsAction = payload => ({
	type: SET_TAX_SYSTEMS,
	payload,
});
export const SET_IS_TAX_SYSTEMS_LOADING = 'accreditation-companies-modal/SET_IS_TAX_SYSTEMS_LOADING';
export const setIsTaxSystemsLoading = payload => ({
	type: SET_IS_TAX_SYSTEMS_LOADING,
	payload,
});

export const GET_TAX_RATES = 'accreditation-companies-modal/GET_TAX_RATES';
export const getTaxRatesAction = payload => ({
	type: GET_TAX_RATES,
	payload,
});

export const SET_TAX_RATES = 'accreditation-companies-modal/SET_TAX_RATES';
export const setTaxRatesAction = payload => ({
	type: SET_TAX_RATES,
	payload,
});
export const SET_IS_TAX_RATES_LOADING = 'accreditation-companies-modal/SET_IS_TAX_RATES_LOADING';
export const setIsTaxRatesLoading = payload => ({
	type: SET_IS_TAX_RATES_LOADING,
	payload,
});
export const RESET_STATE = 'accreditation-companies-modal/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});

export const GET_COMPANY_INFO = 'accreditation-companies-modal/GET_COMPANY_INFO';
export const getCompanyInfoAction = companyId => ({
	type: GET_COMPANY_INFO,
	payload: { companyId },
});

export const SET_COMPANY_INFO = 'accreditation-companies-modal/SET_COMPANY_INFO';
export const setCompanyInfoAction = payload => ({
	type: SET_COMPANY_INFO,
	payload,
});

export const SET_IS_COMPANY_INFO_LOADING = 'accreditation-companies-modal/SET_IS_COMPANY_INFO_LOADING';
export const setIsCompanyInfoLoadingAction = payload => ({
	type: SET_IS_COMPANY_INFO_LOADING,
	payload,
});

export const SEND_ACCREDITATION = 'accreditation-companies-modal/SEND_ACCREDITATION';
export const sendAccreditationAction = ({ id, redirect }) => ({
	type: SEND_ACCREDITATION,
	payload: { id, redirect },
});

export const SET_IS_SENDING_ACCREDITATION = 'accreditation-companies-modal/SET_IS_SENDING_ACCREDITATION';
export const setIsSendingAccreditationAction = payload => ({
	type: SET_IS_SENDING_ACCREDITATION,
	payload,
});
